import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchEdiRfidAuditRequestCreate from '../../api/EdiRfidAuditRequestCreateAPI';
import { EDI_RFID_AUDIT_REQUEST_CREATE_REQUEST } from '../actions/types/EdiRfidAuditRequestCreateActionsTypes';
import { postEdiRfidAuditCreateSuccessActionCreator, postEdiRfidAuditCreateFailureActionCreator } from '../actions/EdiRfidAuditRequestCreateActions';
import { languageSelector } from '../../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../locales/locales';
import { getRedirectInit } from '../../../../../../common/redux/actions/redirectActions';

function* doEdiRfidAuditCreateWorker(action) {
  const lang = yield select(languageSelector);

  try {
    const res = yield call(apiFetchEdiRfidAuditRequestCreate, action.payload);
    yield put(postEdiRfidAuditCreateSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.edirfidauditrequest.create.success'),
    }));
    yield put(getRedirectInit('/edi-rfid-audit'));
  } catch (error) {
    let message = formatMessage(lang, 'app.server.error');
    if (error.response.data.BusinessError !== undefined) {
      const { messageKey } = error.response.data.BusinessError;
      if (messageKey.includes('auditNameShouldBeUnique')) {
        message = formatMessage(lang, 'constraints.ediRfidAuditRequest.auditNameShouldBeUnique');
      } else if (messageKey.includes('startDateShouldBeAfterThanNow')) {
        message = formatMessage(lang, 'constraints.ediRfidAuditRequest.startDateShouldBeAfterThanNow');
      }
    }
    yield put(postEdiRfidAuditCreateFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message,
    }));
  }
}

function* doEdiRfidAuditCreateWatcher() {
  yield takeLatest(EDI_RFID_AUDIT_REQUEST_CREATE_REQUEST, doEdiRfidAuditCreateWorker);
}

export default doEdiRfidAuditCreateWatcher;
